import { render, staticRenderFns } from "./ContactsLeftMenu.vue?vue&type=template&id=60dcf04c&"
import script from "./ContactsLeftMenu.vue?vue&type=script&lang=js&"
export * from "./ContactsLeftMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports